import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import colors from '@honeybook/hbui/dist/styles/colors';
import { isEmailValid } from '~/utils/emails.utils';
import { AnalyticsEvents } from '~/services/analytics/analytics-events';
import { useRootStore } from '~/stores/useRootStore';
import useAnalytics from '~/common/useAnalytics';
import HBButton from '@honeybook/hbui/dist/components/HBButton/HBButton';
import styled from 'styled-components';
import { useModal } from '~/providers/modal.provider';
import { getClickShareTemplateSource } from '~/components/Templates/templates.utils';
import HBInput from '@honeybook/hbui/dist/components/HBInput/HBInput';

const MemberSharingModalContent = () => {
    const {
        templatesUiStore: { selectedTemplate, editSharedWithEmail },
        templatesCtrl
    } = useRootStore();
    const { t } = useTranslation(NAMESPACES.TEMPLATES, {
        keyPrefix: 'share_template.member_sharing'
    });
    const { track } = useAnalytics();
    const [isEmailNotValid, setIsEmailNotValid] = useState(false);
    const { closeModal } = useModal();
    const inputEmail = useRef<HTMLInputElement>();

    const handleShareTemplate = () => {
        if (!isEmailValid(inputEmail.current?.value)) {
            setIsEmailNotValid(true);
            return;
        }
        editSharedWithEmail(inputEmail.current?.value);
        setIsEmailNotValid(false);
        track(AnalyticsEvents.ShareFlowTemplate, {
            source: getClickShareTemplateSource(),
            original_template_id: selectedTemplate?._id
        });
        templatesCtrl.shareTemplate(track);
        closeModal('PublicTemplateConfiguration');
    };

    return (
        <Content>
            <HBText type="body14">{t('description')}</HBText>
            <SendTemplate>
                <EmailInput
                    testIdName="email"
                    customTheme={{
                        background: isEmailNotValid
                            ? colors.red50_15
                            : colors.neutral100
                    }}
                    placeholder="example@email.com"
                    onEnterKey={handleShareTemplate}
                    ref={inputEmail}
                />
                <SendButton
                    id="send-template"
                    onClick={handleShareTemplate}
                    buttonTheme="secondary-solid-secondary"
                >
                    {t('send_cta')}
                </SendButton>
            </SendTemplate>
        </Content>
    );
};

export default MemberSharingModalContent;

const SendTemplate = styled.div`
    display: flex;
    flex-direction: row;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 464px;
    padding: 24px 32px;
`;

const SendButton = styled(HBButton)`
    margin-left: 16px;
`;

const EmailInput = styled(HBInput)`
    margin: 0 8px;
`;
